import { JSX } from 'react';
import HomePage from '../app/home-page';
import PrivacyPolicies from '../app/privacy-policies';
import Products from '../app/products';
import Services from '../app/services';
import Company from '../app/company';

export const routes = {
	home: '/',
	privacyPolicies: '/politica-de-privacidade',
	products: '/produtos',
	services: '/servicos',
	company: '/empresa',
	contact: '/contato'
}

export const pages = {
	home: <HomePage/>,
	privacyPolicies: <PrivacyPolicies/>,
	products: <Products/>,
	services: <Services/>,
	company: <Company/>,
	contact: <div>Contato</div>
};

export const setPageFromUrl = (): JSX.Element => {
	const url = window.location.pathname;

	switch (url) {
		case routes.privacyPolicies:
			return pages.privacyPolicies;
		case routes.products:
			return pages.products;
		case routes.services:
			return pages.services;
		case routes.company:
			return pages.company;
		case routes.home:
			return pages.home;
		default:
			window.location.replace('/');
			return <></>;
	}
}
